import { createRoutesView } from 'atomic-router-react';
import { AlertsPage } from '../pages/alerts';
import { ChartsPage } from './lazy-pages';
import { NotFoundPage } from '../pages/not-found';
import { PositionPage } from '../pages/position';
import { PositionsPage } from '../pages/positions';
import { SettingsPage } from '../pages/settings';
import { StatsPage } from '../pages/stats';
import { WatchlistPage } from '../pages/watchlist';
import { routes } from '../shared/routing';

export const RoutesView = createRoutesView({
  routes: [
    { route: routes.positions, view: PositionsPage },
    { route: routes.position, view: PositionPage },
    { route: routes.alerts, view: AlertsPage },
    { route: routes.stats, view: StatsPage },
    { route: routes.charts, view: ChartsPage },
    { route: routes.watchlist, view: WatchlistPage },
    { route: routes.settings, view: SettingsPage },
    // Signed in, /sign-in has nothing to show: app/model.ts sends it on to the positions.
    { route: routes.signIn, view: PositionsPage },
    { route: routes.notFound, view: NotFoundPage },
  ],
});
